import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DialogSize } from '../../confirmation-dialog/enumerations/dialog-size.enum';
import { ConfirmationDialogType } from '../../confirmation-dialog/models/confirmation-dialog.config';
import { processErrorMessage } from '../error-processor';
import { ErrorUnion } from '../models/error-message';

@Injectable({ providedIn: 'root' })
export class ErrorMessageService {
   private showErrorMessageDialogs = true;

   constructor(private confirmationService: ConfirmationDialogService) {}

   /**
    * Shows an error message to the user. Returns an observable that emits and completes when the user dismisses the error.
    * @param errorMessage The error to show.
    */
   openErrorDialog(errorMessage: ErrorUnion): Observable<boolean | undefined> {
      if (this.showErrorMessageDialogs) {
         const errorData = processErrorMessage(errorMessage);
         const dialogRef = this.confirmationService.confirm({
            data: {
               dialogType: ConfirmationDialogType.Ok,
               header: errorData.details ?? 'Error',
               message: errorData.userMessages.join('\n') ?? 'An Error Occurred',
            },
            size: DialogSize.Small,
         });
         return dialogRef.afterClosed();
      }
      return EMPTY;
   }

   preventErrorMessageDialogDisplay(): void {
      this.showErrorMessageDialogs = false;
      this.confirmationService.closeAll();
   }

   allowErrorMessageDialogDisplay(): void {
      this.showErrorMessageDialogs = true;
   }
}
